import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector } from '../../../../../app/hooks';

const VendorNumberEdit: React.FC = () => {
  const { currentVendor } = useAppSelector(state => state.vendor);

  if (!currentVendor?.id) return null;

  return (
    <TextField
      label="Vendor Number"
      size="small"
      fullWidth
      value={currentVendor?.vendorNumber || ''}
      InputProps={{ readOnly: true }}
      sx={{ '& .MuiInputBase-input': { backgroundColor: '#f1f5f9' } }}
    />
  );
};

export default VendorNumberEdit;
